module.exports = __webpack_public_path__ + "src/assets/games/42/33.jpg";